module.exports = __webpack_public_path__ + "static/media/ColibrisBlanc.0ad78473.png";